<template>
  <div>
    <div>
      <div>
        <InputSearch
          class="mb-3"
          :search="search"
          @clickSearch="onSearch"
          :placeholder="'ค้นหา ประเภท'"
        />
        <v-layout wrap dense class="mb-2">
          <v-flex xs6 style="display: flex; align-items: center">
            <!-- <div class="headline primary--text  bold7 fs-24">ตั้งค่า ข้อมูลประเภทสมาชิก</div> -->
            <Typography h2 bold label="ตั้งค่า ข้อมูลประเภทสมาชิก" />
          </v-flex>
          <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-xs-right" style="display: flex; align-items: flex-end">
              <v-btn
                @click="showModalAdd"
                :style="`color: ${$vuetify.theme.primary};  text-transform: capitalize;`"
                :color="`color: ${$vuetify.theme.primary}`"
                outline
                ><i class="fas fa-plus mr-1"></i>{{ $t('Add') }}</v-btn
              >
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          expand
          hide-actions
          :headers="headers"
          :items="desserts"
          :loading="loading"
          select-all
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="header in props.headers"
                :key="header.text"
                @click="changeSort(header.value)"
              >
                <div>{{ header.text }}</div>
              </th>
            </tr>
            <!-- <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                ]"
                class="text-xs-center"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr> -->
          </template>
          <template v-slot:items="props">
            <!-- <tr v-if="showEdit.includes(props.item.typeid)" :style="{ backgroundColor: '#ecf7ff' }">
              <td class="text-xs-center">{{ props.item.typeid }}</td>
              <td>
                <div class="form-control" :class="{ 'has-error': errors.has('type') }">
                  <input
                    v-validate="'required'"
                    name="type"
                    v-model="props.item.type"
                    type="text"
                    class="depainput rsu"
                  />
                  <span
                    style="font-size: 14px; color: red"
                    class="text-error mb-2"
                    v-show="errors.has('type')"
                    >{{ errors.first('type') }}</span
                  >
                </div>
              </td>
              <td>
                <div class="form-control">
                  <DropdownMenu
                    class="form-control"
                    name="verification"
                    :options="typeOptions"
                    v-model="props.item.verification"
                  >
                    <input
                      readonly
                      :value="props.item.verification"
                      type="text"
                      class="depainput rsu"
                    />
                  </DropdownMenu>
                </div>
              </td>
              <td class="text-xs-center">
                <div style="color: red; z-index: 999">
                  <div class="form-control">
                    <DropdownMenu
                      class="form-control"
                      name="verification"
                      :options="caseOptions"
                      v-model="props.item.allow_case"
                    >
                      <input
                        readonly
                        :value="props.item.allow_case"
                        type="text"
                        class="depainput rsu"
                      />
                    </DropdownMenu>
                  </div>
                </div>
              </td>
              <td class="text-xs-center">
                <div style="color: red; z-index: 999">
                  <div class="form-control">
                    <DropdownMenu
                      class="form-control"
                      name="verification"
                      :options="statusOptions"
                      v-model="props.item.status"
                    >
                      <input
                        readonly
                        :value="props.item.status"
                        type="text"
                        class="depainput rsu"
                      />
                    </DropdownMenu>
                  </div>
                </div>
              </td>
              <td style="white-space: nowrap" class="rsu">
                <v-btn
                  @click="saveedit(props.item)"
                  round
                  class="mr-0 rsu"
                  color="primary"
                  depressed
                  small
                >
                  {{ $t('Save') }}
                </v-btn>
                <v-btn
                  @click="cancelEdit(props.item)"
                  round
                  color="primary"
                  class="rsu"
                  outline
                  small
                >
                  {{ $t('cancel') }}
                </v-btn>
              </td>
            </tr> -->
            <tr>
              <td class="text-xs-left">{{ props.item.typeid }}</td>
              <td class="text-xs-left">{{ props.item.type }}</td>
              <td class="text-xs-left">{{ props.item.verification }}</td>
              <td class="text-xs-left">
                <div style="color: red; width: 380px">
                  {{ props.item.allow_case }}
                </div>
              </td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td style="white-space: nowrap">
                <TooltipTable
                  :datas="props"
                  @modalEdit="showModalEdit(props.item)"
                  @Delete="clickDelete(props.item)"
                  showDelete
                ></TooltipTable>
                <!-- <v-btn @click="showModalEdit(props.item)" icon outline>
                  <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
                </v-btn>
                <v-btn @click="clickDelete(props.item)" icon outline>
                  <v-icon>mdi-delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog v-model="modalAdd" width="500px" persistent>
      <MemberTypeAdd v-if="modalAdd" @close="modalAdd = false" @onSave="onSaveAdd"></MemberTypeAdd>
    </v-dialog>
    <v-dialog v-model="modalEdit" width="500px" persistent>
      <MemberTypeEdit
        v-if="modalEdit"
        @close="modalEdit = false"
        v-model="inputEdit"
        @onSave="onSaveEdit"
      ></MemberTypeEdit>
    </v-dialog>
  </div>
</template>

<script>
import MemberInfoEdit from '../memberInfo/MemberInfoEdit.vue'
import Multiselect from 'vue-multiselect'
import api from '@/api'
import { mapGetters } from 'vuex'
import MemberTypeAdd from './MemberTypeAdd.vue'
import MemberTypeEdit from './MemberTypeEdit.vue'
import axios from 'axios'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Typography from '@/components/elements/Typography.vue'

export default {
  components: {
    MemberInfoEdit,
    Multiselect,
    MemberTypeAdd,
    DropdownMenu,
    InputSearch,
    MemberTypeEdit,
    TooltipTable,
    Typography,
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  data() {
    return {
      loading: true,
      modalAdd: false,
      modalEdit: false,
      showTooltip: false,
      menu: false,
      pagination: {
        sortBy: 'name',
      },
      typeOptions: ['ไม่มี Tax ID', 'มี Tax ID', 'บุคคลธรรมดา', 'เกษตรกร'],
      inputEdit: {},
      showEdit: [],
      showEditObj: [],
      caseOptions: [
        'CASE 1: ERROR มีข้อมูลนี้อยู่แล้ว กรุุณากรอกใหม่อีกครั้ง',
        'CASE 2: NOTIFY ให้คนที่ลงทะเบียนคนแรก Approve',
        'CASE 3: Add เข้าองค์กรอัตโนมัติ',
      ],
      statusOptions: ['บุคคลธรรมดา', 'นิติบุคคล'],
      desserts: [],
      search: {
        nameAll: '',
      },
      headers: [
        {
          text: 'รหัสประเภท',
          align: 'center',
          value: 'typeid',
        },
        {
          text: 'ประเภท',
          align: 'center',
          value: 'type',
        },
        {
          text: 'การตรวจสอบ',
          align: 'center',
          value: 'verification',
        },
        {
          text: 'กรณีที่อนุญาต',
          align: 'center',
          value: 'allow_case',
        },
        {
          text: 'สถานะ',
          align: 'center',
          value: 'status',
        },
        {
          text: '',
          align: 'center',
          value: '',
        },
      ],
    }
  },
  async mounted() {
    this.loading = true
    await this.getdepamembertypeall()
    this.loading = false
  },
  methods: {
    clickDelete(item) {
      this.showTooltip = false
      this.$swal
        .fire({
          type: 'question',
          text: 'ยืนยันการลบ?',
          showCancelButton: true,
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            api.depadeletemembertypebyid(
              { typeid: item.typeid, pageid: this.selectedBot.pageid },
              (err, response) => {
                this.loading = false
                this.getdepamembertypeall()
              }
            )
          }
        })
    },
    onSaveAdd() {
      this.modalAdd = false
      this.getdepamembertypeall()
      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">เพิ่มข้อมูลสำเร็จ</div>',
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
      })
    },
    showModalAdd() {
      this.modalAdd = true
    },
    onSaveEdit() {
      this.modalEdit = false
      this.getdepamembertypeall()
      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
      })
    },
    showModalEdit(item) {
      this.modalEdit = true
      this.inputEdit = item
      this.showEdit = item.typeid
    },
    async onSearch() {
      this.loading = true
      await this.getdepamembertypeall()
      this.loading = false
    },
    getdepamembertypeall() {
      return new Promise((resolve) => {
        var search = {}
        console.log('Object.entries(this.search)', Object.entries(this.search))
        for (const [key, value] of Object.entries(this.search)) {
          Object.assign(search, { [key]: value })
        }
        console.log('XXX', { ...search })
        api.getdepamembertypeall(
          { pageid: this.selectedBot.pageid, ...search, active: true },
          (err, response) => {
            if (response.responsecode == 200) {
              this.desserts = response.data
              resolve()
            }
          }
        )
      })
    },
    // cancelEdit(item) {
    //   var index = this.desserts.findIndex((el) => el.typeid == item.typeid)
    //   var edittempIndex = this.showEditObj.findIndex((el) => el.typeid == item.typeid)
    //   this.$set(this.desserts, index, this.showEditObj[edittempIndex])
    //   var editIndex = this.showEdit.findIndex((el) => el == item.typeid)
    //   this.showEdit.splice(editIndex, 1)
    // },
    // async saveedit(item) {
    //   var isValid = await this.$validator.validate()
    //   if (isValid) {
    //     var index = this.desserts.findIndex((el) => el.typeid == item.typeid)
    //     await this.saveServerEdit(item)
    //     this.desserts[index] = item
    //     var editIndex = this.showEdit.findIndex((el) => el == item.typeid)
    //     this.showEdit.splice(editIndex, 1)
    //   }
    // },
    // saveServerEdit(item) {
    //   return new Promise((resolve) => {
    //     var data = {
    //       pageid: this.selectedBot.pageid,
    //       ...item,
    //     }
    //     api.putdepamembertype(data, (err, response) => {
    //       if (response.data.responsecode == 200) {
    //         resolve()
    //       } else {
    //         resolve()
    //       }
    //     })
    //   })
    // },
    closemodal() {
      this.editModal = false
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
  },
}
</script>

<style>
.multiselect--active {
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// src/components/view/memberType/main.vue